import { render, staticRenderFns } from "./InfoBadge.vue?vue&type=template&id=2cad3586&scoped=true&"
import script from "./InfoBadge.vue?vue&type=script&lang=js&"
export * from "./InfoBadge.vue?vue&type=script&lang=js&"
import style0 from "./InfoBadge.vue?vue&type=style&index=0&id=2cad3586&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad3586",
  null
  
)

export default component.exports